export const SUPER_ADMIN = "SUPER_ADMIN";

export const ADMIN = "ADMIN";

export const CHATTER = "CHATTER";

export const MODERATOR = "MODERATOR";

export const REGULAR = "REGULAR";
